import { AppContext } from '../../context';
import { useContext, useEffect } from 'react';
import classnames from 'classnames';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const style = require('./DatePickerOptionsToggle.module.scss');

interface DatePickerOptionsToggleProps {
    handleChecked: () => void;
    isChecked: boolean;
    primaryColor?: string;
}

const DatePickerOptionsToggle = ({ handleChecked, isChecked, primaryColor }: DatePickerOptionsToggleProps) => {
    const { translate } = useContext(AppContext);

    useEffect(() => {
        if (primaryColor) {
            document.documentElement.style.setProperty('--primary-date-picker-color', primaryColor);
        }
    }, [primaryColor]);

    const inputType = 'checkbox';
    const inputName = 'selectOptions';
    const minScreenWidth = 284;
    const isMinScreenWidth = window.innerWidth <= minScreenWidth;
    const labelText = !isMinScreenWidth
        ? translate('pickDays:showOptionsThatSpanMultipleDays')
        : translate('pickDays:showOptions');
    const singleDayText = !isMinScreenWidth ? translate('pickDays:singleDayOptions') : translate('pickDays:single');
    const multiDayText = !isMinScreenWidth ? translate('pickDays:multiDayOptions') : translate('pickDays:multi');

    return (
        <>
            {isChecked ? (
                <div className={style.optionsDisplayContainer}>
                    <div className={style.optionsContainer}>
                        <div className={classnames(style.optionCircle, style.borderSolid)}></div>
                        <div className={style.optionTextContainer}>{singleDayText}</div>
                    </div>
                    <div className={style.optionsContainer}>
                        <div className={classnames(style.optionCircle, style.borderDashed)}></div>
                        <div className={style.optionTextContainer}>{multiDayText}</div>
                    </div>
                </div>
            ) : (
                <div className={style.datePickerOptionsContainer}>
                    <input
                        type={inputType}
                        className={style.optionsInput}
                        name={inputName}
                        checked={isChecked}
                        onChange={handleChecked}
                    />
                    <label className={style.optionsLabel} htmlFor={style.optionsInput}>
                        {labelText}
                    </label>
                </div>
            )}
        </>
    );
};

export default DatePickerOptionsToggle;
